// utils/agGridDateColumn.js

// 🔹 formatira datum u "dd.mm.yyyy"
const formatDate = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d)) return "";
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
};

// 🔹 komparator koji poredi samo datume, bez vremena
const dateComparator = (filterLocalDateAtMidnight, cellValue) => {
  if (!cellValue) return -1;
  const cellDate = new Date(cellValue);
  const filterTime = filterLocalDateAtMidnight.getTime();
  const cellTime = new Date(
    cellDate.getFullYear(),
    cellDate.getMonth(),
    cellDate.getDate()
  ).getTime();
  if (cellTime === filterTime) return 0;
  return cellTime < filterTime ? -1 : 1;
};

// 🔹 helper funkcija za kreiranje ag-grid datumske kolone
export const createDateColumn = (headerName, field, extra = {}) => ({
  headerName,
  field,
  filter: "agDateColumnFilter",
  valueGetter: (params) => {
    const value = params.data?.[field];
    return value ? new Date(value) : null;
  },
  valueFormatter: (params) => formatDate(params.value),
  filterParams: {
    comparator: dateComparator,
    browserDatePicker: true,
  },
  ...extra, // omogućava dodatne override-e (npr. width, flex, minWidth)
});

export const formatFullDate = (date) => {
  if (!date) return "";
  const d = new Date(date);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  const seconds = String(d.getSeconds()).padStart(2, "0");

  return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
};

export const createFullDateColumn = (headerName, field, extra = {}) => ({
  headerName,
  field,
  filter: "agDateColumnFilter",

  // 1️⃣ vrati Date objekat da filter radi
  valueGetter: (params) => {
    const value = params.data?.[field];
    return value ? new Date(value) : null;
  },

  // 2️⃣ formatiraj full datum sa vremenom
  valueFormatter: (params) => formatFullDate(params.value),

  // 3️⃣ date filter comparator
  filterParams: {
    comparator: dateComparator,
    browserDatePicker: true,
  },

  ...extra,
});
